import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import searcher from "../../assets/searchInput.svg";
import { useDispatch } from "react-redux";
import TableContainer from "../layouts/table-container/table-container";
import ErrorPopup from "../popups/ErrorPopup";
import ChangeSaved from "../popups/ChangeSaved";
import CloseIcon from "../../assets/icons/closeIcon";
import "../modals/bulk-upload/bulk-upload.css";
import { AdminButton } from "../buttons/versionHistoryBtn";
import Select from "react-select";
import {
  productDoctorsOfferRequest,
  productViewDoctorList,
} from "../../redux/actions/productActions";
import LoadingSpinnerTable from "../utilites/loader";
import AddDoctorTableModal from "./addDoctorTable";

const DoctorProductsTableModal = ({
  show,
  ShowClose,
  ShowOpen,
  selectedOfferDetails,
  selectedOfferList,
}) => {
  const [offerList, setOfferList] = useState([]);
  const [loading, setloading] = useState(false);
  const [doctorsList, setDoctorsList] = useState([]);
  const [filterDoctorArray, setfilterDoctorArray] = useState([]);
  const [productVerifiedList, setProductVerifiedList] = useState([]);
  const dispatch = useDispatch();
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState();
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState();
  const [addDoctorShow, setAddDoctorShow] = useState(false);

  console.log(selectedOfferDetails, "selectedOfferList");

  useEffect(() => {
    if (selectedOfferList.length > 0) {
      let newArr = selectedOfferList.map((ele) => ({
        value: ele?.id,
        label:
          ele?.offer_type === "quantity"
            ? `${ele?.offer} + ${ele?.offer_qty}`
            : ele.after_off,
      }));
      setOfferList(newArr);
    }
  }, [selectedOfferList]);

  useEffect(() => {
    if (show) {
      if (selectedOfferDetails.id) {
        setloading(true);
        dispatch(
          productViewDoctorList(
            { offer_id: selectedOfferDetails?.id },
            onDoctorSuccess,
            onDoctorError
          )
        );
      }
    }
  }, [show]);

  const onDoctorSuccess = (data) => {
    setDoctorsList(data.data.data);
    setfilterDoctorArray(data.data.data);
    setloading(false);
  };
  const onDoctorError = (err) => {
    setloading(false);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    setShowErrorPopup(true);
  };

  const checkedProduct = (e, item) => {
    const { checked } = e.target;

    setProductVerifiedList((prevList) => {
      if (checked) {
        return [
          ...prevList,
          {
            offer_id: "",
            request_id: item.id,
            doctor_id: item.doctor.id,
          },
        ];
      } else {
        return prevList.filter((obj) => obj.doctor_id !== item.doctor.id);
      }
    });
  };

  const handleOfferChange = (selectedOption, item) => {
    setProductVerifiedList((prevList) =>
      prevList.map((obj) =>
        obj.doctor_id === item.doctor.id
          ? { ...obj, offer_id: selectedOption.value }
          : obj
      )
    );
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const searchHandler = (e) => {
    console.log(e.target.value == "");

    if (e.target.value === "") {
      setfilterDoctorArray(doctorsList);
    } else {
      let newArr = doctorsList.filter(
        (doctor) =>
          doctor.doctor.name
            .toLowerCase()
            .includes(e.target.value.toLowerCase()) ||
          doctor.doctor.code
            .toLowerCase()
            .includes(e.target.value.toLowerCase())
      );
      setfilterDoctorArray(newArr);
    }
  };

  const doctorsOffersSubmit = () => {
    dispatch(
      productDoctorsOfferRequest(
        { doctorOffers: productVerifiedList },
        onDoctorOfferSuccess,
        onDoctorOfferError
      )
    );
  };
  const timeOutFnc = () => {
    setShowSuccessPopup(false);
  };

  const onDoctorOfferSuccess = (data) => {
    setShowSuccessPopup(true);
    const str = data.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowSuccessMsg(str_modify);
    setTimeout(timeOutFnc, 2000);
  };
  const onDoctorOfferError = (err) => {
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    setShowErrorPopup(true);
  };

  return (
    <>
      <Modal
        centered
        show={show}
        onHide={ShowClose}
        dialogClassName="doctor-data-table-container col-12 px-5 mx-auto"
        size="lg"
      >
        <ModalHeader className="d-flex justify-content-between align-items-center">
          <div className="d-flex justify-content-between w-100 align-items-center">
            <span className="fn_Nunito fw_700 fs_22">Doctor</span>
            <button className="border-0 bg-white" onClick={() => ShowClose()}>
              <CloseIcon fill="black" width={"14px"} />
            </button>
          </div>
        </ModalHeader>
        <ModalBody className="text-nowrap">
          <div className="modal-table-container">
            <div className="search-container d-flex justify-content-between w-100">
              <div className="search-box w-50 d-flex align-items-center p-2 ms-3 m-1 mb-2">
                <img className="styled-SVG" src={searcher} color={""} />
                <input
                  className="search-input fw_400 px-2 text-dark"
                  type="text"
                  placeholder="Search Doctor here by Doctor Name and Code..."
                  onChange={searchHandler}
                />
              </div>
              <AdminButton
                background="#7065E4"
                color="white"
                width="180px"
                onClick={() => {
                  ShowClose();
                  setAddDoctorShow(true);
                }}
              >
                <span className="m-2 fw_700">ADD DOCTOR</span>
              </AdminButton>
            </div>

            <TableContainer>
              <thead>
                <tr className="table-rows color_747f9e">
                  <th className="table-heads " width={"2%"}></th>
                  <th className="table-heads " width={"12%"}>
                    Doctor Code
                  </th>
                  <th className="table-heads " width={"9%"}>
                    Doctor Name
                  </th>
                  <th className="table-heads " width={"12%"}>
                    Offer
                  </th>
                </tr>
              </thead>
              <tbody style={{ position: "relative" }}>
                {loading === true ? (
                  <div className="list-spinner-container">
                    <LoadingSpinnerTable />
                  </div>
                ) : (
                  <>
                    {filterDoctorArray?.map((item, index) => (
                      <tr className="table-rows1" key={index}>
                        <td className="table-each-row-data" width={"3%"}>
                          <input
                            type="checkbox"
                            className="superCheck"
                            id={`checkbox-${index}`}
                            name="prodcutsCheck"
                            onChange={(e) => checkedProduct(e, item)} // Pass individual item
                            checked={productVerifiedList.some(
                              (obj) => obj.doctor_id === item.doctor.id
                            )}
                          />
                        </td>
                        <td className="table-each-row-data">
                          {item.doctor.code}
                        </td>
                        <td className="table-each-row-data">
                          {item.doctor.name}
                        </td>
                        <td className="table-each-row-data">
                          {productVerifiedList.some(
                            (obj) => obj.doctor_id === item.doctor.id
                          ) ? (
                            <div
                              style={{ maxWidth: "140px" }}
                              className="w-100 pe-2"
                            >
                              <Select
                                options={offerList}
                                styles={customStyles}
                                placeholder="Select offer"
                                onChange={(selectedOption) =>
                                  handleOfferChange(selectedOption, item)
                                }
                              />
                            </div>
                          ) : (
                            `${selectedOfferDetails?.offer} + ${selectedOfferDetails?.offer_qty}`
                          )}
                        </td>
                      </tr>
                    ))}{" "}
                  </>
                )}
              </tbody>
            </TableContainer>
          </div>
          <div className="my-2 mt-4">
            {productVerifiedList.length > 0 && (
              <div className="d-flex gap-4 justify-content-end">
                <AdminButton
                  background="#7065E4"
                  color="white"
                  width="180px"
                  onClick={doctorsOffersSubmit}
                >
                  <span className="m-2 fw_700">Confirm</span>
                </AdminButton>
              </div>
            )}
          </div>
        </ModalBody>
      </Modal>
      <ChangeSaved show={showSuccessPopup} title={showSuccessMsg} />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
      <AddDoctorTableModal
        offerId={selectedOfferDetails.id}
        show={addDoctorShow}
        doctorListOpen={ShowOpen}
        ShowClose={() => {
          setAddDoctorShow(false);
        }}
      />
    </>
  );
};

export default DoctorProductsTableModal;

export const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    border: "1px solid #B0B3C7",
    color: "#464646",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    padding: "0.1rem",
    fontSize: "15px",
    borderRadius: "8px",
    width: "100%",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "#B0B3C7",
      fontSize: "14px",
      fontFamily: "Nunito Sans",
    };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: "#a9a3e3", // Custom colour
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#E7E5FF" : null,
    color: "#00000",
    // fontFamily: "Nunito",
    "&:hover": {
      backgroundColor: state.isFocused ? "#E7E5FF" : "#E7E5FF",
    },
  }),
};
